import React from 'react';
import { icons } from '../../../constants';
import { formatCustomDateIsoString } from '../../../services/dateService';

export const externalClientSatisfactionColumns = [
  {
    field: "clientName",
    header: "Cliente",
    columnWidth: "120px"
  },
  {
    field: "receptionDate",
    header: "Fecha de recepción",
    columnWidth: "140px",
    columnType: "custom",
    render: (rowData) => (
      <span>{rowData.receptionDate ? formatCustomDateIsoString(String(rowData.receptionDate)) : ""}</span>
    )
  },
  {
    field: "receptionTime",
    header: "Hora de recepción",
    columnWidth: "140px"
  },
  {
    field: "physicalLocation",
    header: "Ubicación Física",
    columnWidth: "140px"
  },
  {
    field: "orderNumber",
    header: "Nro de Orden",
    columnWidth: "120px"
  },
  {
    field: "p1",
    header: "P1",
    columnWidth: "80px"
  },
  {
    field: "p2",
    header: "P2",
    columnWidth: "80px"
  },
  {
    field: "p3",
    header: "P3",
    columnWidth: "80px"
  },
  {
    field: "p4",
    header: "P4",
    columnWidth: "80px"
  },
  {
    field: "p5",
    header: "P5",
    columnWidth: "80px"
  },
  {
    field: "p6",
    header: "P6",
    columnWidth: "80px"
  },
  {
    field: "p7",
    header: "P7",
    columnWidth: "80px"
  },
  {
    field: "rating",
    header: "Calificación",
    columnWidth: "120px"
  },
  {
    field: "actions",
    header: "",
    columnType: "custom",
    columnWidth: "120px",
    render: (rowData, onCopyLink, onViewResults) => {
      return (
        <div className="table-column-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
          <button
            onClick={() => onCopyLink(rowData.surveyLinkToken || rowData.surveyOrderId)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="Copiar link de encuesta"
          >
            <img
              src={icons.linkBlue}
              alt="Copiar link"
              style={{ width: '20px', height: '20px' }}
            />
          </button>

          <button
            onClick={() => onViewResults(rowData.answerId)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="Ver resultados de la encuesta"
          >
            <img
              src={icons.eye || '/icons/eye.png'}
              alt="Ver resultados"
              style={{ width: '20px', height: '20px' }}
            />
          </button>
        </div>
      );
    }
  }
];
